import { extendObservable } from 'mobx'
import get from 'lodash/get'
import { notificationApi } from '@atheneum/api'

class NotificationStore {
  constructor (growlStore) {
    this.growlStore = growlStore
    this.limit = 15
  }

  getInitialState () {
    return {
      notifications: [],
      page: 0,
      count: 0,
      countAll: 0,
      loading: false,
      listLoaded: false,
      loadMore: false,
      initNotificationTypes: false,
      notificationTypes: {},
      deliveryTypes: [],
      notificationList: [],
      error: null
    }
  }

  init () {
    extendObservable(this, this.getInitialState())
    this.getNotificationList()
  }

  notificationListener (socket, currentUser) {
    socket.on('notification', data => {
      this.handleNotification(data, currentUser)
    })
  }

  handleNotification (data, currentUser) {
    if (data.type === 'ANNOUNCE_DEPLOYMENT' || data.type === 'LAST_REMINDER') {
      return this.growlStore.addNotification({
        message: data.message,
        type: 'warning'
      })
    }

    const notificationSetting = get(
      currentUser,
      'employee.settings.notification.' + data.type
    )
    this.count += 1

    const notification = {
      message: data.message,
      linkTo: data.link,
      type: 'info'
    }
    switch (notificationSetting.deliveryType) {
      case 'popup':
        return this.growlStore.addNotification({
          ...notification,
          autoClose: true
        })
      case 'sticky':
        return this.growlStore.addNotification(notification)
      default:
        return null
    }
  }

  getDropdownNotifications () {
    this.loading = true
    notificationApi.get().then(data => {
      this.notifications.replace(data.notifications)
      this.count = 0
      this.loading = false
    })
  }

  getNotificationList () {
    const offset = this.page * this.limit
    if (this.page === 1) {
      this.loadMore = true
    }
    notificationApi.get(this.limit, offset).then(({ notifications, count }) => {
      this.countAll = count
      const notificationList = this.notificationList.concat(notifications)
      this.notificationList.replace(notificationList)
      this.listLoaded = true
      this.loadMore = false
    })
  }

  getNotificationCount () {
    notificationApi.getCount().then(data => {
      this.count = data[0].total
    })
  }

  getNotificationTypes () {
    notificationApi.getNotificationTypes().then(data => {
      this.notificationTypes = data.types
      this.deliveryTypes.replace(data.deliveryTypes)
      this.initNotificationTypes = true
    })
  }

  loadMoreNotifications () {
    this.page = this.page + 1
    this.getNotificationList()
  }

  update = (notification, status) => {
    notificationApi
      .update(notification.id, { ...notification, status })
      .then(() => {
        this.count = 0
      })
  }
}

export default NotificationStore
